import { memo } from 'react'
import * as Styled from './styled'
import VisualMediaTracks from './VisualMediaTracks'
import AudioTracks from './AudioTracks'
import { useActiveItemsDrag } from './hooks/active-items-drag'

const Tracks = () => {
  const hasDragged = useActiveItemsDrag()

  return (
    <Styled.TracksWrapper>
      <Styled.Tracks>
        <VisualMediaTracks preventOnClick={hasDragged} />
        <AudioTracks preventOnClick={hasDragged} />
      </Styled.Tracks>
    </Styled.TracksWrapper>
  )
}

export default memo(Tracks)
